import { useState } from 'react'
import {
  OFFER_STATUS_WAITING,
  OFFER_STATUS_WAITING_VERIFICATION
} from 'tennders-stracture/libs/constants'
import Countdown from 'react-countdown'
import GHref from 'tennders-market/common/components/element/GHref'
import Trans from 'next-translate/Trans'
import { SingleOfferTimer } from '../SingleOfferTimer'

export const DealTimer = (props) => {
  const {
    offer,
    confirmDeal,
    rejectOffer,
    refreshTransaction,
    setRefresh
  } = props
  const [submitting, setsubmitting] = useState(false)
  const [rejecting, setrejecting] = useState(false)
  const [submittingreject, setsubmittingreject] = useState(false)

  const accept = async () => {
    setsubmitting(true)
    await confirmDeal(offer?.id)

    setsubmitting(false)
  }

  const reject = async () => {
    if (!rejecting) {
      setrejecting(true)
      return
    }

    setsubmittingreject(true)
    await rejectOffer(offer?.id)
    setsubmittingreject(false)
    setRefresh('all')
    refreshTransaction()
  }

  return offer?.timer && (offer?.status?.label === OFFER_STATUS_WAITING_VERIFICATION || offer?.status?.label === OFFER_STATUS_WAITING)
    ? (
      <div className="tennders-under-neg-confirm-deal text-center">
        <strong>
          <Countdown
            date={Date.now() + offer.timer * 1000}
            renderer={SingleOfferTimer}
          />
        </strong>
        <div className="d-flex align-center justify-center mt-10">
          <GHref
            submitting={submitting}
            onClick={accept}
            className="btn-border standard-btn small tennders-confirm-deal-btn"
          >
            <Trans i18nKey="offer:confirmDeal" />
          </GHref>
          <GHref
            submitting={submittingreject}
            onClick={reject}
            className="text-underline tennders-decline-btn-2 ml-24"
          >
            {rejecting ? <Trans i18nKey="offer:confirmReject" /> : <Trans i18nKey="offer:decline" />}
          </GHref>
        </div>
      </div>
    )
    : null
}
